import React from 'react'
import { Link } from 'react-router'

const ServicesNav = (props) => {
  return (
    <>
    <div className="services-nav pt-140 pb-150">
            <div className="container">
                <div className="ul_li_between">
                    <Link to={"/" + props.prev.toLowerCase().replace(/\s+/g, "-")} className="service-nav-item">
                        <span className="sd-link"><i className="fal fa-long-arrow-left"></i> PREVIOUS</span>
                        <h2 className="sd-title">{props.prev}</h2>
                    </Link>
                    <Link className="JatinHomeService" to="/services"><img src="assets/img/icon/SD.svg" alt=""/></Link>
                    <Link to={"/" + props.next.toLowerCase().replace(/\s+/g, "-")} className="service-nav-item service-nav-item--next">
                        <span className="sd-link">Next <i className="fal fa-long-arrow-right"></i></span>
                        <h2 className="sd-title">{props.next}</h2>
                    </Link>
                </div>
            </div>
        </div>
    </>
  )
}

export default ServicesNav
